import PropTypes from 'prop-types'
import { cn } from '../../_utils/cn'
import { MenuArrow } from './MenuArrow'
import { menuVariants } from '../variants/Menu.variants'

/**
 * Panel desplegable del menú. Contiene columnas de Nivel 2 y opcionalmente Nivel 3.
 * @param {Object} props
 * @param {string} [props.id]
 * @param {boolean} [props.isOpen]
 * @param {string} [props.triggerId]
 * @param {string} [props.className]
 * @param {string} [props.dataTestId]
 * @param {boolean} [props.showArrow]
 * @param {React.ReactNode} props.children
 */
export const MenuPanel = ({ id, isOpen, triggerId, className, dataTestId, showArrow = true, children }) => {
  if (!isOpen) return null

  return (
    <div
      id={id}
      role="menu"
      aria-labelledby={triggerId}
      data-testid={dataTestId}
      className={cn(menuVariants.panel(), className)}
    >
      {showArrow && <MenuArrow isOpen={isOpen} className="-top-3 left-1/2 -translate-x-1/2" />}
      {children}
    </div>
  )
}

MenuPanel.displayName = 'MenuPanel'

MenuPanel.propTypes = {
  id: PropTypes.string,
  isOpen: PropTypes.bool,
  triggerId: PropTypes.string,
  className: PropTypes.string,
  dataTestId: PropTypes.string,
  showArrow: PropTypes.bool,
  children: PropTypes.node,
}
